import React, {useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiMenu, FiX} = FiIcons;

const links = [
  ['Identität', '#identitaet'],
  ['Design', '#design'],
  ['Zielgruppe', '#zielgruppe'],
  ['Wording', '#copy'],
  ['Event-Wochenende', '#wochenende']
];

function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="site-header">
      <button
        className="menu-toggle"
        onClick={() => setOpen(!open)}
        aria-label={open ? 'Menü schließen' : 'Menü öffnen'}
        aria-expanded={open}
      >
        <SafeIcon icon={open ? FiX : FiMenu} />
      </button>
      <nav className={`site-nav${open ? ' nav-open' : ''}`} aria-label="Hauptnavigation">
        {links.map(([label, href]) => (
          <a key={href} href={href} onClick={() => setOpen(false)}>{label}</a>
        ))}
      </nav>
    </header>
  );
}

export default SiteHeader;